<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/unauthenticated"></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row style="padding-left: 1em; padding-right: 1em;">
      <ion-col>
        <p>
          <strong>We've sent you a 6 digit verification code.</strong>&nbsp;It should appear above the keyboard in the next few seconds.
        </p>
        <p>
          Select the code and it will autofill in the text box.
        </p>
        <p>
          Click VERIFY CODE to complete.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-xs="12" size-md="6" offset-md="3" size-lg="4" offset-lg="4">
        <form [formGroup]="verifyCodeForm" (ngSubmit)="verifyCode()">
          <ion-item lines="none">
            <ion-label position="stacked" class="auth-button-label">{{fieldNames.code}}</ion-label>
            <ion-input 
              class="auth-input"
              autocomplete="one-time-code"
              expand="full"
              type="tel"
              position="stacked"
              formControlName="code"
              color="input-text"
              maxlength="8"
              aria-placeholder="SMS Code"
              placeholder="Insert code"
              #code
            ></ion-input>
            <control-label [control]="verifyCodeForm.controls['code']" [fieldName]="fieldNames['code']"></control-label>
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
    <ng-container *ngIf="!showAdditionalContent">
      <ion-row style="padding-left: 1em; padding-right: 1em; text-align: center;">
        <ion-col>
          <p>
            <a href="javascript:void(0)" *ngIf="!showAdditionalContent" (click)="triggerShowAdditionalContent()">NO SMS? Click here.</a>
          </p>
        </ion-col>
      </ion-row>
    </ng-container>
    <ng-container *ngIf="showAdditionalContent">
      <ion-row style="padding-left: 1em; padding-right: 1em;">
        <ion-col>
          <p>
            You may also get an SMS message notification. You can check your SMS messages and type in the code manually.
          </p>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="showResendButton">
        <ion-col style="text-align: center;">
          Didn't receive the verification code?<br/><a href="javascript:void(0)" (click)="resendCode()">Re-send SMS.</a>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>
</ion-content>

<ion-footer class="auth-footer">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button expand="block" type="submit" class="auth-button primary" [disabled]="!verifyCodeForm.valid" (click)="verifyCode()">Verify Code</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
